



































































import Vue from "vue";
import SkillsAnimation from "@/components/modules/skills/SkillsAnimation.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  DEMAND_SKILL_DATA,
  FETCH_DEMAND_SKILLS
} from "@/store/modules/institute/constants";
import SkillHeader from "@/components/modules/skills/SkillHeader.vue";
import { get_skill_related_data } from "@/utils/skills_data";
import CustomSelect from "@/components/shared/CustomSelect.vue";

export default Vue.extend({
  name: "SkillMap",
  components: { SkillsAnimation, SkillHeader, CustomSelect },
  data() {
    return {
      selected_city: {
        text: "Dubai",
        img: "/cities/Dubai.png",
        value: "Dubia"
      } as any,
      pagination: 1,
      limit: 60,
      page: 1,
      loading: false
    };
  },
  computed: {
    ...mapGetters("institute", {
      get_demand_data: DEMAND_SKILL_DATA
    }),
    cityBackgroundStyle(): any {
      return {
        backgroundImage: `url(${this.selected_city.img})`
      };
    },
    selected_data(): any {
      return this.get_demand_data.results.slice(
        (this.page - 1) * this.limit,
        this.page * this.limit
      );
    }
  },
  watch: {
    selected_city() {
      this.initiateData();
    }
  },
  async mounted() {
    this.selected_city = this.get_skill_related_data("UAE_States").find(
      (item: any) => item?.text === this.get_demand_data.state
    );
    await this.initiateData();
  },
  methods: {
    get_skill_related_data,
    ...mapActions("institute", {
      get_skill_demand: FETCH_DEMAND_SKILLS
    }),
    ...mapMutations("institute", {
      set_skill_demand: DEMAND_SKILL_DATA
    }),
    async initiateData() {
      this.page = 1;
      this.loading = true;
      const payload = {
        page: this.get_demand_data.page,
        limit: this.get_demand_data.limit,
        state: this.selected_city.text,
        job_title: this.get_demand_data.job_title,
        industry: this.get_demand_data.industry,
        category: this.get_demand_data.category
      };
      await this.get_skill_demand(payload);
      // if (data1) {
      //   this.selected_data = this.get_demand_data.results;
      // } else {
      //   this.selected_data = [];
      // }
      this.loading = false;
    },
    extractData(page: number) {
      this.page = page;
      // this.initiateData();
    },
    change_city(item: any) {
      this.selected_city = item;
      this.initiateData();
    }
  }
});
